import type { challenges as en } from '@/i18n/locales/en/challenges';
import type { Translation } from '@/i18n/types';

/** See `src/i18n/locales/en/challenges.ts`. */
export const challenges: Translation<typeof en> = {
  page: {
    title: 'Retos',
    lead: 'Organiza retos de equipo: pasos, sueño, entrenamientos y más, con una clasificación opcional.',
    noCompany: 'Selecciona una empresa para ver sus retos.',
    forbidden: 'No tienes acceso a los retos de esta empresa.',
    empty: 'Todavía no hay retos — crea el primero.',
  },
  counts: {
    active: 'Retos activos',
    draft: 'Borradores',
    completed: 'Finalizados',
    totalParticipants: 'Participantes totales',
  },
  sections: {
    activePublished: 'Activos y publicados',
    draftsCompleted: 'Borradores y finalizados',
  },
  card: {
    type: 'Tipo',
    mode: 'Modalidad',
    period: 'Periodo',
    goal: 'Objetivo',
    reward: 'Recompensa',
    participants: 'Participantes',
    engagement: 'Interacción',
    completion: 'Finalización',
    leaderboardVisible: 'Clasificación visible',
    leaderboardHidden: 'Clasificación oculta',
  },
  mode: {
    individual: 'Individual',
    group: 'Equipo',
  },
  status: {
    draft: 'Borrador',
    active: 'Activo',
    paused: 'En pausa',
    completed: 'Finalizado',
  },
  type: {
    steps: 'Pasos',
    sleep: 'Sueño',
    workouts: 'Entrenamientos',
    meditation: 'Meditación',
    custom: 'Personalizado',
  },
  actions: {
    newChallenge: 'Nuevo reto',
    publish: 'Publicar',
    pause: 'Pausar',
    resume: 'Reanudar',
    finish: 'Finalizar',
    duplicate: 'Duplicar como borrador',
    duplicateSuffix: 'copia',
    viewLeaderboard: 'Ver clasificación',
    hideLeaderboard: 'Ocultar clasificación',
  },
  leaderboard: {
    title: 'Clasificación',
    empty: 'Todavía no hay participantes.',
  },
  form: {
    title: 'Nuevo reto',
    submit: 'Crear reto',
    cancel: 'Cancelar',
    fields: {
      title: 'Título',
      description: 'Descripción',
      type: 'Tipo',
      mode: 'Modalidad',
      startDate: 'Fecha de inicio',
      endDate: 'Fecha de fin',
      goalValue: 'Valor objetivo',
      unit: 'Unidad',
      reward: 'Recompensa',
      leaderboardVisible: 'Mostrar clasificación a los participantes',
    },
    errors: {
      required: 'Este campo es obligatorio.',
      endBeforeStart: 'La fecha de fin no puede ser anterior a la fecha de inicio.',
    },
  },
};
